module.exports = __webpack_public_path__ + "img/164.fd99f868.png";